module.exports = __webpack_public_path__ + "img/menu01a.91282558.svg";